import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgTgeTrade = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 40 40"
    ref={ref}
    {...props}
  >
    <g fill="#D9D9D9" filter="url(#tge-trade_svg__a)">
      <path d="m16.707 11.185 3.688-3.094-1.974-.173a.862.862 0 1 1 .15-1.717l4.047.355a.86.86 0 0 1 .783.934l-.355 4.047a.862.862 0 0 1-1.717-.151l.173-1.974-3.688 3.093a.862.862 0 1 1-1.107-1.32M14 23.447v7.106c0 .582-.486 1.08-1.054 1.08h-.892v2.287c0 .581-.486 1.08-1.054 1.08s-1.054-.499-1.054-1.08v-2.286h-.892A1.06 1.06 0 0 1 8 30.554v-7.107c0-.582.486-1.08 1.054-1.08h.892V20.08c0-.582.486-1.08 1.054-1.08s1.054.498 1.054 1.08v2.285h.892c.568 0 1.054.5 1.054 1.08M20 16a1 1 0 0 1 1 1v2h1a1 1 0 0 1 1 1v14h-2v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1-1-1V20a1 1 0 0 1 1-1h1v-2a1 1 0 0 1 1-1M29 12a1 1 0 0 1 1 1v2h1a1 1 0 0 1 1 1v16h-2v2a1 1 0 1 1-2 0v-2h-1a1 1 0 0 1-1-1V16a1 1 0 0 1 1-1h1v-2a1 1 0 0 1 1-1" />
    </g>
    <defs>
      <filter
        id="tge-trade_svg__a"
        width={24}
        height={31.802}
        x={8}
        y={6.198}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 0.25 0" />
        <feBlend in2="shape" result="effect1_innerShadow_141_25240" />
      </filter>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgTgeTrade);
export default ForwardRef;
